"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const inputColorClass = (value, errorMessage) => {
  if (errorMessage && errorMessage.length > 0) return 'input is-danger';
  if (value && value.length > 0 && !errorMessage) return 'input is-success';
  return '';
};
var _default = exports.default = inputColorClass;
//# sourceMappingURL=inputColorClass.js.map